var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _vm.consultar
              ? _c(
                  "button",
                  {
                    staticClass: "btn-success btn--bigger",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.exportarExcel()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-file-excel-o" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Excel")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.consultar
              ? _c(
                  "button",
                  {
                    staticClass: "btn-info btn--bigger",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.botonConsultar()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-search" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Consultar")])
                  ]
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          tooltip: _vm.selectedPersona
                            ? _vm.selectedPersona.nombre
                            : null,
                          placeholder: "Busque y seleccione...",
                          id: "persona",
                          options: _vm.optionPersonas,
                          label: "nombre"
                        },
                        on: {
                          input: _vm.inputPersona,
                          search: _vm.onSearchPersona
                        },
                        model: {
                          value: _vm.selectedPersona,
                          callback: function($$v) {
                            _vm.selectedPersona = $$v
                          },
                          expression: "selectedPersona"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "persona" } }, [
                        _vm._v("Cliente")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-info",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.buscarPersona()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-search" })]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-8" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-inline" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipo_fecha_inicio,
                          expression: "form.tipo_fecha_inicio"
                        }
                      ],
                      attrs: { type: "radio", value: "T" },
                      domProps: {
                        checked: _vm._q(_vm.form.tipo_fecha_inicio, "T")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "tipo_fecha_inicio", "T")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("A la fecha")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipo_fecha_inicio,
                          expression: "form.tipo_fecha_inicio"
                        }
                      ],
                      attrs: { type: "radio", value: "P" },
                      domProps: {
                        checked: _vm._q(_vm.form.tipo_fecha_inicio, "P")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "tipo_fecha_inicio", "P")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Personalizado")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.tipo_fecha_inicio == "P",
                          expression: "form.tipo_fecha_inicio == 'P'"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("VueCtkDateTimePicker", {
                            attrs: {
                              id: "fecha_desde_inicio",
                              locale: "es",
                              "only-datetime": "",
                              "no-label": "",
                              "button-now-translation": "Ahora",
                              format: "YYYY-MM-DD HH:mm",
                              formatted: "YYYY-MM-DD HH:mm",
                              label: "Seleccione fecha..."
                            },
                            model: {
                              value: _vm.form.fecha_desde_inicio,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fecha_desde_inicio", $$v)
                              },
                              expression: "form.fecha_desde_inicio"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Desde")]),
                          _vm._v(" "),
                          _vm.errores.fecha_desde_inicio
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.errores.fecha_desde_inicio[0]
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.tipo_fecha_inicio == "P",
                          expression: "form.tipo_fecha_inicio == 'P'"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("VueCtkDateTimePicker", {
                            attrs: {
                              id: "fecha_hasta_inicio",
                              locale: "es",
                              "only-datetime": "",
                              "no-label": "",
                              "button-now-translation": "Ahora",
                              format: "YYYY-MM-DD HH:mm",
                              formatted: "YYYY-MM-DD HH:mm",
                              label: "Seleccione fecha..."
                            },
                            model: {
                              value: _vm.form.fecha_hasta_inicio,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fecha_hasta_inicio", $$v)
                              },
                              expression: "form.fecha_hasta_inicio"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Hasta")]),
                          _vm._v(" "),
                          _vm.errores.fecha_hasta_inicio
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.errores.fecha_hasta_inicio[0]
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-7" }, [
              _c("div", { staticClass: "form-inline" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estado,
                        expression: "form.estado"
                      }
                    ],
                    attrs: { type: "radio", value: "P" },
                    domProps: { checked: _vm._q(_vm.form.estado, "P") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estado", "P")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Pendiente")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estado,
                        expression: "form.estado"
                      }
                    ],
                    attrs: { type: "radio", value: "FA" },
                    domProps: { checked: _vm._q(_vm.form.estado, "FA") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estado", "FA")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Facturado")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estado,
                        expression: "form.estado"
                      }
                    ],
                    attrs: { type: "radio", value: "FF" },
                    domProps: { checked: _vm._q(_vm.form.estado, "FF") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estado", "FF")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Finalizado")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estado,
                        expression: "form.estado"
                      }
                    ],
                    attrs: { type: "radio", value: "I" },
                    domProps: { checked: _vm._q(_vm.form.estado, "I") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estado", "I")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Anulado")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estado,
                        expression: "form.estado"
                      }
                    ],
                    attrs: { type: "radio", value: "T" },
                    domProps: { checked: _vm._q(_vm.form.estado, "T") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estado", "T")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Todos")])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card mt-2" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c(
            "div",
            { staticClass: "table-responsive" },
            [
              _c("vue-good-table", {
                ref: "listaReporteProyectos",
                attrs: {
                  columns: [
                    {
                      label: "Código",
                      field: "codigo"
                    },
                    {
                      label: "Cliente",
                      field: "nombre_persona"
                    },
                    {
                      label: "Proyecto",
                      field: "nombre"
                    },
                    {
                      label: "Descripción",
                      field: "descripcion"
                    },
                    {
                      label: "Fecha Inicio",
                      field: "fecha_inicio"
                    },
                    {
                      label: "Estado",
                      field: "nombre_estado"
                    },
                    {
                      label: "Comprobantes",
                      field: "comprobantes"
                    },
                    {
                      label: "Costos por Proyecto",
                      field: "costos_proyectos"
                    }
                  ],
                  mode: "remote",
                  "pagination-options": {
                    enabled: true,
                    perPage: 10,
                    nextLabel: "siguiente",
                    prevLabel: "anterior",
                    rowsPerPageLabel: "Registros por página",
                    ofLabel: "de",
                    allLabel: "Todo",
                    dropdownAllowAll: true,
                    perPageDropdownEnabled: true,
                    perPageDropdown: [10, 20, 30, 40, 50]
                  },
                  rows: _vm.registros,
                  "search-options": {
                    enabled: false,
                    placeholder: "Buscar..."
                  },
                  styleClass: "vgt-table"
                },
                on: {
                  "on-page-change": _vm.onPageChange,
                  "on-per-page-change": _vm.onPerPageChange
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-row",
                    fn: function(props) {
                      return [
                        props.column.field == "comprobantes"
                          ? _c("span", [
                              _c("div", { staticClass: "table-responsive" }, [
                                _c("table", [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [_vm._v("# Comp.")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Cliente")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("F. Emisión")])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(props.row.comprobantes, function(
                                        comprobante
                                      ) {
                                        return _c(
                                          "tr",
                                          { key: comprobante.id_comprobante },
                                          [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  comprobante.numero_documento
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  comprobante.nombre_cliente
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm
                                                    .moment(
                                                      comprobante.fecha_emision
                                                    )
                                                    .format("YYYY-MM-DD")
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "tr",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                props.row.comprobantes
                                                  .length === 0,
                                              expression:
                                                "props.row.comprobantes.length === 0"
                                            }
                                          ]
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "3" } },
                                            [
                                              _c("strong", [
                                                _vm._v("No hay comprobantes.")
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ])
                            ])
                          : props.column.field == "costos_proyectos"
                          ? _c("span", [
                              _c("div", { staticClass: "table-responsive" }, [
                                _c("table", [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [_vm._v("Descripción")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Fecha")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Valor")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Observación")])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(
                                        props.row.costos_proyectos,
                                        function(costo) {
                                          return _c("tr", { key: costo.id }, [
                                            _c("td", [
                                              _vm._v(_vm._s(costo.descripcion))
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm
                                                    .moment(costo.fecha)
                                                    .format("YYYY-MM-DD")
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.moneyFormat(costo.valor)
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(costo.observacion))
                                            ])
                                          ])
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "tr",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                props.row.costos_proyectos
                                                  .length === 0,
                                              expression:
                                                "props.row.costos_proyectos.length === 0"
                                            }
                                          ]
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "4" } },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  "No hay costos por proyecto."
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ])
                            ])
                          : _c("span", [
                              _vm._v(
                                _vm._s(props.formattedRow[props.column.field])
                              )
                            ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "55%",
            height: "auto",
            name: "listaPersonas",
            scrollable: ""
          }
        },
        [
          _c("lista-personas", {
            attrs: { tipoFiltro: "C", filterStatus: false },
            on: {
              selected: _vm.seleccionarPersona,
              consultar: _vm.consultarPagina
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte de proyectos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Filtros")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Fecha inicio")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Filtros por estado")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Resultados de la consulta")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0da32d63", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0da32d63","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/ReporteProyectos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0da32d63","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/ReporteProyectos.vue
// module chunks = 0